import '.d{display:flex;}.ssr-plugin'
import '.g{gap:1rem;}.ssr-plugin'
import Column from '@app/components/layout/Column'
import {
  regionsTabsQueryParamName,
  regionsTabs,
} from '@app/pages/discover/regions/constants'
import { labelAddressBuilder } from '@app/util/helpers'
import { SectionHeader } from '../../sectionHeader/SectionHeader'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'
import useMediaQuery from '@app/util/useMediaQuery'
import { pages } from '@app/util/links'
import { RegionalListInitiativeModel } from 'functions/app/initiative/list-regional'
import { InitiativeCard } from '../../card/InitiativeCard'
import defaultProjectPicture from '@app/assets/defaultProjectPicture.png'

export type InitiativesContentSectionType = {
  type: 'initiatives'
  title: string
  items: RegionalListInitiativeModel[]
}

export const InitiativesContentSection = ({
  title,
  items,
}: InitiativesContentSectionType) => {
  const t = useTranslations().app
  const isMobile = useMediaQuery()

  if (items.length === 0) return null

  return (
    <Column alignItems="stretch" gap={0}>
      <SectionHeader
        title={title}
        seeMore={t.common.seeMore}
        toRoute={`?${regionsTabsQueryParamName}=${regionsTabs.initiatives}`}
      />
      <div className="d g"
        style={{
          flexDirection: isMobile ? 'column' : 'row',
        }}
      >
        {items.map((initiative) => (
          <InitiativeCard
            key={initiative.slug}
            to={pages.initiative(initiative.slug)}
            image={initiative.images?.[0] ?? defaultProjectPicture}
            title={initiative.title}
            description={initiative.description}
            location={labelAddressBuilder(
              initiative.location?.address,
              t.common.notSpecified,
              'regional',
            )}
            phase={initiative.phase?.name}
            tagText={
              initiative.searchingForMembers
                ? t.common.initiativeStatus.searchingForMembers
                : t.common.initiativeStatus.notSearchingForMembers
            }
            tagVariant={initiative.searchingForMembers ? 'success' : 'neutral'}
          />
        ))}
      </div>
    </Column>
  )
}
